// extracted by mini-css-extract-plugin
export var clauseRow = "_fl-6";
export var emptyState = "_fl-d";
export var filterContent = "_fl-a";
export var filterGroup = "_fl-1";
export var filterGroupContainer = "_fl-0";
export var nestedGroup = "_fl-2";
export var nestedGroupContent = "_fl-b";
export var nestedGroupDepth1 = "_fl-3";
export var nestedGroupDepth2 = "_fl-4";
export var nestedGroupDepth3 = "_fl-5";
export var nestedGroupEmpty = "_fl-c";
export var operatorAnd = "_fl-8";
export var operatorOr = "_fl-9";
export var operatorToggle = "_fl-7";
export var removeGroupButton = "_fl-e";